import { render, staticRenderFns } from "./guides.vue?vue&type=template&id=948540e8&scoped=true"
import script from "./guides.vue?vue&type=script&lang=js"
export * from "./guides.vue?vue&type=script&lang=js"
import style0 from "./guides.vue?vue&type=style&index=0&id=948540e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948540e8",
  null
  
)

export default component.exports